import React from "react";

/**
 * CommonInput - Premium rounded pill text / number / email / password input.
 *
 * Props:
 *   label       {string}   Label shown above the input
 *   required    {boolean}  Appends a red asterisk to the label
 *   type        {string}   HTML input type (default: "text")
 *   placeholder {string}
 *   value       {any}
 *   onChange    {function}
 *   readOnly    {boolean}
 *   disabled    {boolean}
 *   height      {string}   Input height (default: "45px")
 *   error       {string}   Error message to display below the input
 *   style       {object}   Extra style overrides for the input element
 *   className   {string}   Extra classes for the input element
 *   labelClass  {string}   Extra classes for the label element
 *   wrapClass   {string}   Extra classes for the wrapping div
 */
const CommonInput = ({
  label,
  required = false,
  type = "text",
  placeholder = "",
  value,
  onChange,
  readOnly = false,
  disabled = false,
  height = "45px",
  error,
  style = {},
  className = "",
  labelClass = "",
  wrapClass = "",
  ...props
}) => {
  return (
    <div className={wrapClass}>
      {label && (
        <label className={`text-black fw-bold mb-1 ${labelClass}`}>
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        disabled={disabled}
        className={`form-control ${className}`}
        {...props}
        style={{
          height: height,
          backgroundColor: readOnly || disabled ? "#f8f9fa" : "#fff",
          color: readOnly || disabled ? "#adb5bd" : "inherit",
          border: error ? "1px solid #ff5e5e" : "1px solid #d5dfe7",
          borderRadius: "0.75rem",
          padding: "0 20px",
          ...style,
        }}
      />
      {error && <div className="text-danger fs-12 mt-1 ms-3">{error}</div>}
    </div>
  );
};

export default CommonInput;
